export { default } from './InstallationSummaryModalConnector';

